import { useEffect, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from './store';
import { authApi } from '@/lib/api/endpoints';
import { Skeleton } from '@/components/ui/skeleton';

export const CHANGE_PASSWORD_PATH = '/alterar-senha';

/**
 * Restaura a sessão via cookie de refresh antes de decidir redirecionar.
 * Com troca de senha pendente, só a própria tela de troca fica acessível.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { accessToken, user, hydrated, setHydrated } = useAuthStore();
  const location = useLocation();

  useEffect(() => {
    if (hydrated) return;
    if (accessToken) {
      setHydrated();
      return;
    }
    // api() faz o refresh automático no 401
    authApi
      .me()
      .catch(() => undefined)
      .finally(() => setHydrated());
  }, [accessToken, hydrated, setHydrated]);

  if (!hydrated) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Skeleton className="h-10 w-40" />
      </div>
    );
  }
  if (!accessToken) return <Navigate to="/login" state={{ from: location }} replace />;
  if (user?.mustChangePassword && location.pathname !== CHANGE_PASSWORD_PATH) {
    return <Navigate to={CHANGE_PASSWORD_PATH} replace />;
  }
  return <>{children}</>;
}
